import { render } from "./Preloader.vue?vue&type=template&id=4fc2e133&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "@/css/components/c-preloader.css?vue&type=style&index=0&id=4fc2e133&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc2e133"]])

export default __exports__